// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ir","input":"is","button":"it"};